import { render, staticRenderFns } from "./r-modal-card-block.vue?vue&type=template&id=580187fb"
import script from "./r-modal-card-block.vue?vue&type=script&lang=js"
export * from "./r-modal-card-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports